function addtoCart(variant_id) {
	const formData = {
		id: variant_id,
		quantity: 1,
	};

	fetch(`${window.Shopify.routes.root}cart/add.js`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(formData),
	})
		.then((response) => {
			if (!response.ok) {
				throw new Error(`Failed to add to cart: ${response.status}`);
			}
			return response.json();
		})
		.then((data) => {
			console.log("Item added to cart:", data);

			// Trigger cart refresh for Prestige theme
			document.documentElement.dispatchEvent(
				new CustomEvent("cart:refresh", {
					bubbles: true,
				}),
			);
		})
		.catch((error) => {
			console.error("Error adding to cart:", error);
		});
}

function decreaseQuantity(variant_id) {
	fetch(`${window.Shopify.routes.root}cart.js`, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
		},
	})
    .then((response) => {
        if (!response.ok) {
            throw new Error(`Failed to fetch cart: ${response.status}`);
        }
        return response.json();
    })
    .then((cart) => {
        const lineItem = cart.items.find((item) => item.variant_id === variant_id);

        if (!lineItem) {
            console.warn("Item not found in cart.");
            return;
        }

        const newQuantity = lineItem.quantity - 1;
        
        if(newQuantity == 0){
          removeCartItem(lineItem.key);
        }
        else{
          if (newQuantity < 1) {
              if (lineItem.quantity > 1) {
                  removeCartItem(lineItem.key);
              }
          } else {
              updateCartLineItem(lineItem.key, newQuantity);
          }
        }
    })
    .catch((error) => {
        console.error("Error fetching cart:", error);
    });
}

function updateCartLineItem(key, quantity) {
	const formData = {
		id: key,
		quantity: quantity,
	};

	fetch(`${window.Shopify.routes.root}cart/change.js`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(formData),
	})
		.then((response) => {
			if (!response.ok) {
				throw new Error(`Failed to update cart: ${response.status}`);
			}
			return response.json();
		})
		.then((data) => {
			// console.log("Cart item updated:", data);

			// Trigger cart refresh for Prestige theme
			document.documentElement.dispatchEvent(
				new CustomEvent("cart:refresh", {
					bubbles: true,
				}),
			);
		})
		.catch((error) => {
			console.error("Error updating cart line item:", error);
		});
}

function removeCartItem(key) {
	const formData = {
		id: key,
		quantity: 0,
	};

	fetch(`${window.Shopify.routes.root}cart/change.js`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(formData),
	})
		.then((response) => {
			if (!response.ok) {
				throw new Error(`Failed to remove item: ${response.status}`);
			}
			return response.json();
		})
		.then((data) => {
			// console.log("Item removed from cart:", data);

			// Trigger cart refresh for Prestige theme
			document.documentElement.dispatchEvent(
				new CustomEvent("cart:refresh", {
					bubbles: true,
				}),
			);
		})
		.catch((error) => {
			console.error("Error removing cart item:", error);
		});
}
